import React from "react";
import _ from "lodash";
import { Table, Image, Button } from "semantic-ui-react";
import ssnImage from "../../assets/images/ssn.png";

export default function ssnRecord(props) {
  if (props.result === undefined) {
    return null;
  }
  let ssn = _.get(props.result, "ssn[0]._", "");
  if(ssn === "") ssn = _.get(props.result, "SSN[0]._", "");
  let issued = _.get(props.result, "years[0]._");
  if (!issued) {
    issued = _.get(props.result, "issued[0]._", "");
  }
  return (
    <Table className="table-no-border" key={`res_ssn_ver_${props.index}`}>
      <Table.Body>
        <Table.Row>
          <Table.Cell rowSpan={3}>
            <Image src={ssnImage} />
          </Table.Cell>
          <Table.Cell>Status:</Table.Cell>
          <Table.Cell>{_.get(props.result, "status[0]._", "NA")}</Table.Cell>
          <Table.Cell>Issued:</Table.Cell>
          <Table.Cell>{issued === "" ? "NA" : issued}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>State:</Table.Cell>
          <Table.Cell colSpan={3}>
            {_.get(props.result, "state[0]._", "NA")}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell colSpan={4}>
            {_.get(props.result, "error[0]._", "")}
          </Table.Cell>
        </Table.Row>
        {props.userAccount.mastSearchBySSN === 1 && ssn !== "" && (
          <Table.Row>
            <Table.Cell colSpan={5}>
              <Button
                onClick={() =>
                  props.handleNewSearchClick(this, "SSN", ssn, { ssn })
                }
              >
                Run Search On This SSN
              </Button>
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
}



// WEBPACK FOOTER //
// ./src/components/searchresults/SsnRecord.js